import React from 'react'
import { Card } from 'react-bootstrap'
import { formatPrice } from '../../helpers/utils'

const STATUS_LIST = {
  PENDING: {
    badge: 'badge badge-info',
    label: 'รอแจ้งโอน',
  },
  CONFIRMED: {
    badge: 'badge badge-warning',
    label: 'แจ้งโอนแล้ว',
  },
  SUCCESS: {
    badge: 'badge badge-success',
    label: 'ซื้อสำเร็จ',
  },
  CANCEL: {
    badge: 'badge badge-danger',
    label: 'ยกเลิก',
  },
}

const ACTION_LIST = {
  BLOCKED: {
    badge: 'badge badge-dark',
    label: 'มีปัญหา',
  },
  NONE: {
    badge: '',
    label: '',
  },
  IN_PROGRESS: {
    badge: 'badge badge-secondary',
    label: 'ล็อค',
  },
}

export default function OrderListItem({ order, workingStatus, orderDetail, orderIdSelected }) {
  const status = order.status
  const actionOrder = order.action.action
  const isSelected = orderDetail?.id === order.id
  const submitPaymentAt = new Date(order.createdAt).toLocaleString('TH-th')
  const submitPaymentAtSearch = new Date(order.createdAt).toLocaleString('TH-th')
  const checkOrderIsLock = () => {
    if (orderIdSelected.length > 0) {
      return orderIdSelected.some((item) => item.id === order.id)
    }
  }

  return (
    <>
      <Card
        className=" mb-3 "
        style={{
          backgroundColor: isSelected ? `#000` : `#FFF`,
          color: isSelected ? `#FFF` : `#7E7E7E`,
          cursor: 'pointer',
        }}
      >
        <Card.Body>
          {order.action.action === 'IN_PROGRESS' && order.status === 'CONFIRMED' && (
            <div className=" bg-black text-white rounded-lg p-2">
              แอดมินที่ต้องปลดล็อคหรือจัดการคำสั่งซื้อนี้คือ {order.action.adminName}{' '}
            </div>
          )}
          <div
            className="timeline-panel"
            style={{
              display: 'flex',
              marginBottom: '0px',
              paddingBottom: '0px',
              borderBottom: '0px',
            }}
          >
            <div className="d-flex flex-column flex-grow-1">
              <ul>
                {checkOrderIsLock() && <div className="w-full text-center p-2 bg-red rounded-lg ">Watching</div>}
                <li className="d-flex justify-content-between align-items-baseline pt-2">
                  <div>{`#${order.orderNo}`}</div>
                  <div>
                    <span className={STATUS_LIST[status].badge}>{STATUS_LIST[status].label}</span>
                    {order.status === 'CONFIRMED' && (
                      <span className={ACTION_LIST[actionOrder].badge}>{ACTION_LIST[actionOrder].label}</span>
                    )}
                  </div>
                </li>
                <li className="d-flex justify-content-between pt-2">
                  <div>{`${order.user.firstName} ${order.user.lastName}`}</div>
                  <div>{order.user?.userNo || ''}</div>
                </li>
                <li className="d-flex justify-content-between pt-2">
                  <div className="d-flex flex-column text-left">
                    <div>วันที่</div>
                    {workingStatus !== 'search' ? <div>{submitPaymentAt}</div> : <div>{submitPaymentAtSearch}</div>}
                  </div>
                  {/* <div className="d-flex flex-column text-center">
                    <div>ช่องทาง</div>
                    <div>
                      {order.transferFromBankName
                        ? order.transferFromBankName
                        : 'ธนาคาร'}
                    </div>
                  </div> */}
                  <div className="d-flex flex-column text-right">
                    <div>ราคา</div>
                    <div>{`${formatPrice(order?.totalPrice)} บาท`}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}
